import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import List from 'components/v2/list/List';
import { fscPeriodType, getFscSettings } from 'utils/FscSettingsApiUtils';
import { showToast } from 'stores/ToastStore';
import Pagination from 'components/v2/Pagination';
import FSCSettingListItem from './FSCSettingListItem';
const PER_PAGE = 10;
export default function Expired({ accountId, actionsEnabled }) {
    const { t } = useTranslation();
    const [settings, setSettings] = useState([]);
    const [settingsTotal, setSettingsTotal] = useState(0);
    const [settingsTotalPages, setSettingsTotalPages] = useState(1);
    const [settingsPage, setSettingsPage] = useState(1);
    const [loading, setLoading] = useState(false);
    async function loadSettings({ page = 1 }) {
        try {
            setLoading(true);
            const settings = await getFscSettings(accountId, fscPeriodType.EXPIRED, {
                perPage: PER_PAGE,
                skip: (page - 1) * PER_PAGE,
            });
            setSettings((settings === null || settings === void 0 ? void 0 : settings.rows) || []);
            setSettingsTotal((settings === null || settings === void 0 ? void 0 : settings.count) || 0);
            setSettingsTotalPages(Math.ceil(((settings === null || settings === void 0 ? void 0 : settings.count) || 1) / PER_PAGE));
            setSettingsPage(page);
        }
        catch (e) {
            console.error(e);
            showToast(t('ERROR'), t('ERROR_WHILE_RETRIEVING_SETTINGS'), 'error');
        }
        finally {
            setLoading(false);
        }
    }
    function handleSave() {
        loadSettings();
    }
    useEffect(() => {
        loadSettings({ page: 1 });
    }, []);
    return (React.createElement("div", { className: "lx:w-1/2 w-full" },
        React.createElement(List, { title: t('EXPIRED') },
            settings.map((data, i) => (React.createElement(FSCSettingListItem, { data: data, key: i, actionsEnabled: actionsEnabled, onChange: handleSave }))),
            settings.length > 0 && (React.createElement(Pagination, { perPage: PER_PAGE, page: settingsPage, pages: settingsTotalPages, total: settingsTotal, onPageClick: (page) => loadSettings({ page }) }))),
        loading && t('LOADING')));
}
